import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@app/core/authentication';
import { FormFactoryModel } from '@app/shared/common';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'app-table-filters',
  templateUrl: './table-filters.component.html',
})
export class TableFiltersComponent implements OnInit, OnDestroy {
  /**
   * @description
   * This component contains all search fields from PAGES LIST table
   */

  /**
   * * General
   * @subscriptions Subscriptions array
   */
  subscriptions: Subscription[] = [];
  /**
   * * Inputs
   * @searchForm Main FormGroup with search parameters
   * @fieldsService Form fields config
   */
  @Input() searchForm: FormGroup;
  @Input() fieldsService: FormFactoryModel[];
  @Input() openFilterBtnText = 'Filters';
  /**
   * * Outputs
   * @handleSubmit Trigger event when user run search
   */
  @Output() handleSubmit = new EventEmitter<any>();
  curentUser: any;

  constructor(private authService: AuthService) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */

  ngOnInit(): void {
    this.curentUser = this.authService.userValue;

    const arrayOfControls = this.fieldsService.map(
      (field) =>
        this.searchForm.controls[field.options.formControlName].valueChanges
    );

    this.fieldsService = this.fieldsService.filter(
      (field) =>
        field?.roles?.includes(this.curentUser.data.role) || !field?.roles
    );

    arrayOfControls.forEach((control) => {
      this.subscriptions.push(
        control
          .pipe(debounceTime(400), distinctUntilChanged())
          .subscribe((value) => {
            if (value != null && value !== '') {
              this.handleSearch(1);
            }
          })
      );
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */

  handleSearch(event: number = null) {
    this.handleSubmit.emit(event);
  }

  resetFilter() {
    this.fieldsService.forEach((field) => {
      if (field.dummyFields) {
        field.dummyFields.forEach((dummyField) => {
          this.searchForm.get(dummyField.options.formControlName).setValue('');
        });
      } else {
        this.searchForm.get(field.options.formControlName).setValue('');
      }
    });
    this.handleSearch(1);
  }

  /* ====================================
    *                HELPERS
    ======================================= */

  deleteFilterTag(field: string) {
    this.searchForm.controls[field].setValue('');
  }
}
